/**
 * Additional config whitelist extending the original whitelist applied when Jitsi Meet is embedded
 * in another app be that with an iframe or a mobile SDK.
 */
export default [
    'customToolbarButtons',
    'defaultLogoUrl',
    'deploymentUrls',
    'liveStreaming'
];
